import React, { useState, useEffect } from 'react';
import { AIAssistantButton } from './index';

interface AIAssistantIntegrationProps {
  userId: string;
  sessionId?: string;
  language?: string;
}

const AIAssistantIntegration: React.FC<AIAssistantIntegrationProps> = ({
  userId,
  sessionId,
  language = 'en'
}) => {
  const [currentSessionId, setCurrentSessionId] = useState(sessionId || '');

  useEffect(() => {
    // Generate session ID if not provided
    if (!currentSessionId) {
      setCurrentSessionId(`session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);
    }
  }, [currentSessionId]);


  return (
    <AIAssistantButton
      userId={userId}
      sessionId={currentSessionId}
      language={language}
    />
  );
};

export default AIAssistantIntegration;





